import BuyerItemHeader from "./buyerItemHeader";
import BuyerDetails from "./BuyerDetails";
import { DISCARDED_ATTRIBUTES } from "@lib/sharedUtils";
import MainFeatures from "./mainfeatures";
import { GQLOffers } from "@gql/types/gql";

export default function BuyerItemPrimary({
    buyer,
    index,
    categoryId,
}: {
    buyer: GQLOffers;
    index: number;
    categoryId: number;
}) {
    const mainFeatures = buyer.attributes
        ?.filter(
            (el) =>
                !el?.baseAttribute?.hidden &&
                !el?.baseAttribute?.comparison &&
                !DISCARDED_ATTRIBUTES?.includes(
                    el?.baseAttribute?.name as string,
                ) &&
                el?.baseAttribute,
        )
        .slice(0, 3);

    return (
        <>
            <BuyerItemHeader
                buyer={buyer}
                index={index}
                categoryId={categoryId}
            />
            <BuyerDetails buyer={buyer} />
            {mainFeatures && mainFeatures.length > 0 && (
                <MainFeatures
                    mainFeatures={
                        mainFeatures as {
                            value: string;
                            baseAttribute: {
                                name: string;
                                hidden: boolean;
                            };
                        }[]
                    }
                />
            )}
        </>
    );
}
